import React from 'react';
import './detailViewHeader.less';

const DetailViewHeader = props => {
    return (
        <header className="detail-view-header">
            {props.children}
        </header>
    );
}

export default DetailViewHeader;


// WEBPACK FOOTER //
// ./src/react/views/detailView/DetailViewHeader.jsx